import { RecipeCategory } from "./generated/graphql";

export { FormatIngredientDisplayName, FormatQuantityAndUnit, FormatUnitLabel } from "@mealmanager/ingredient-format";

export function GetEnumKeys<
    T extends string,
    TEnumValue extends string | number,
>(enumVariable: { [key in T]: TEnumValue }) {
    return Object.keys(enumVariable) as Array<T>;
}

const CATEGORY_PRIORITY_ORDER = ['Breakfast', 'Lunch', 'Dinner', 'Snack'] as const;

export function byCategoryPriority<T extends string>(a: T, b: T): number {
    const ai = CATEGORY_PRIORITY_ORDER.indexOf(a as typeof CATEGORY_PRIORITY_ORDER[number]);
    const bi = CATEGORY_PRIORITY_ORDER.indexOf(b as typeof CATEGORY_PRIORITY_ORDER[number]);
    if (ai === -1 && bi === -1) return a.localeCompare(b);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
}

export function isLegacyCheatDay(value: string | null | undefined): value is 'CheatDay' {
    return value === 'CheatDay';
}

export function normalizeRecipeCategory(category: RecipeCategory | string | null | undefined): RecipeCategory | undefined {
    if (category == null) {
        return undefined;
    }
    return isLegacyCheatDay(category) ? RecipeCategory.Dinner : category as RecipeCategory;
}

export function formatDisplayedTagName(name: string | null | undefined): string {
    return name === 'Cheat Day' ? 'Treat Meal' : (name ?? '');
}

export function getVisibleRecipeCategoryOptions() {
    return GetEnumKeys(RecipeCategory).sort(byCategoryPriority).map((key) => ({
        value: RecipeCategory[key],
        label: RecipeCategory[key].toString(),
    }));
}
